export const environment = {
    production: false,
    config: {
        "backend": {
            "baseUri": "auth.tobuildonline.nl",
            "loginPath": "login",
            "tokenPath": "oauth2/token",
            "clientId": "2n9lv7r2h4rd2dh95spv436v2c",
            "clientSecret": "bf5tmer37h13a2gbfoc6aa6oi52roja6dsoktt7otgroil9hu4h"
        },
        "data": {
            "baseUri": "https://dev-api.calculatie.tobuildonline.nl"
        },
        "auth": {
            "requiredGroup": "calculatie-dev"
        },
        "changelog": {
            "uri": "https://versions.tobuildonline.nl/dev"
        }
    },
    version: '1.3.6'
}